export default "__VITE_PUBLIC_ASSET__a9a14d22__"